import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import _, { templateSettings } from 'underscore';
import { makeStyles } from '@mui/styles';
import {
	Button, TextField, Typography, Grid, Select, Card,
	CardHeader, CardContent, Divider, Accordion, AccordionSummary,
	AccordionDetails
} from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import EmailIcon from '@mui/icons-material/Email';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import EditIcon from '@mui/icons-material/Edit';
import { DataTable, Label, Chart } from 'components';
import { SetFormState } from '../../../../../../../../../../../actions/VoiceActions';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	errorButton: {
		color: theme.palette.error.main
	},
	infoButton: {
		color: theme.palette.info.main
	}
}));

const Layer3Charts = (props) => {
	const { className, data, ...rest } = props;
	const dispatch = useDispatch();
	const classes = useStyles();

	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.voiceReducer.formState);

	const layer3Kpis = useSelector((state) => state.voiceReducer.layer3Kpis);

	const verticalLineData = {
		label: 'Time',
		data: [{ x: layer3Kpis.graphLineTime, y: -140 }, { x: layer3Kpis.graphLineTime, y: 20 }],
		borderColor: 'black', // Cor da linha
		type: 'line', // Tipo de gráfico
		fill: false, // Não preencha a área sob a linha
		pointRadius: 0, // Não mostre pontos de dados para a linha
		borderWidth: 2 // Largura da linha
	};

	let graphWithLine = layer3Kpis.datasets;
	if (layer3Kpis.graphLineTime !== null && layer3Kpis.graphLineTime !== undefined) {
		graphWithLine = [...layer3Kpis.datasets || [], verticalLineData];
	}

	return (
		<div style={{ height: '35vh' }}>
			<Chart
				id="chartOne"
				data={graphWithLine || []}
				dataLabels={layer3Kpis.labels || []}
				options={{
					title: {
						display: true,
						text: 'KPIs',
						fontSize: 20
					},
					legend: {
						display: true,
						position: 'right'
					},
					maintainAspectRatio: false, // Impede que o gráfico mantenha a proporção
					responsive: true, // Torna o gráfico responsivo
					// height: 20, // Define a altura desejada em pixels
				}}
			/>
		</div>
	);
};

Layer3Charts.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default Layer3Charts;
